class ProductListCategory extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({"opacity":"1"});

      var swiper = new Swiper(".productcategoryslider", {
      slidesPerView:3.5,
      spaceBetween:25,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
          320: {
            slidesPerView:3.5,   
            spaceBetween: 20
          },
          480: {
            slidesPerView:3.5,
            spaceBetween: 25
          },
          640: {
            slidesPerView:4.5,
            spaceBetween: 25
          },
         990: {
            slidesPerView:6.5,
            spaceBetween: 25
         },
         1024: {
           slidesPerView:8.5,
           spaceBetween: 25
         },
        1200: {
          slidesPerView:10.5,
          spaceBetween: 30
         },
        1441:{
          slidesPerView:11.5,
          spaceBetween: 35
        }
      },
    });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);          
  }
}
customElements.define("product-list-category", ProductListCategory);




//--------- New Product Template Frame Drawer -----------------//


function toggleAddon() {
  var selectedValue = $('input[name="Frame Color"]:checked').val();
  if (!selectedValue) return;

  var value = selectedValue.toUpperCase().trim();

  var $wrapper = $('.custom_addon_item_wrapper');
  var $checkbox = $wrapper.find('input[type="checkbox"]');

  if (value === 'UNFRAMED POSTER' || value === 'CANVAS' || value === 'UNFRAMED') {
    $wrapper.css('opacity', '0.5');
    $checkbox
      .prop('disabled', true)
      .prop('checked', false)
      .css('cursor', 'not-allowed');
  } else {
    $wrapper.css('opacity', '1');
    $checkbox
      .prop('disabled', false)
      .css('cursor', 'pointer');
  }
}



// Run on page load
$(document).ready(function () {
  toggleAddon();
});

// Run when Type option changes
$(document).on('change', 'input[name="Frame Color"]', function () {
  toggleAddon();
});

//------------
// Main Drawer

  $('.trigger_frame_drawer').click(function () {
    $('#custom_frame_drawer_container').addClass('open');
    $('.drawer-color-option').removeClass('active');
    $('.drawer-color-option[data-value="UNFRAMED POSTER"]').addClass('active');
    $('.drawer-color-option[data-value="CANVAS"]').addClass('active');
    $('.drawer-color-option[data-value="UNFRAMED"]').addClass('active');
      $('html').addClass('js-drawer-open lock-scroll');
      console.log('clicked');
      $('.variant-input[data-value="UNFRAMED POSTER"] label[data-varcolorproduct="UNFRAMED POSTER"]').trigger('click');
      $('.variant-input[data-value="CANVAS"] label[data-varcolorproduct="CANVAS"]').trigger('click');            
      $('.variant-input[data-value="UNFRAMED"] label[data-varcolorproduct="UNFRAMED"]').trigger('click');            
    });
    
  $('.custom_frame_drawer_overlay').click(function () {
        $('.custom_information_drawer').removeClass('open');
    $('.custom_item_info_drawer').removeClass('open');
    $('.custom_item_frame_info_drawer').removeClass('open');

    $('#custom_frame_drawer_container').removeClass('open');
    $('html').removeClass('js-drawer-open lock-scroll');
    $('.variant-input[data-value="UNFRAMED POSTER"] label[data-varcolorproduct="UNFRAMED POSTER"]').trigger('click');
    $('.variant-input[data-value="CANVAS"] label[data-varcolorproduct="CANVAS"]').trigger('click');
    $('.variant-input[data-value="UNFRAMED"] label[data-varcolorproduct="UNFRAMED"]').trigger('click'); 
     $('#add-to-cart-btn').click();
  });
  
  $('.custom_frame_drawer .frame_drawer_close').click(function () {
      $('html').addClass('js-drawer-open lock-scroll');
          $('.custom_information_drawer').removeClass('open');
    $('.custom_item_info_drawer').removeClass('open');
    $('.custom_item_frame_info_drawer').removeClass('open');

    $('#custom_frame_drawer_container').removeClass('open');
    $('.variant-input[data-value="UNFRAMED POSTER"] label[data-varcolorproduct="UNFRAMED POSTER"]').trigger('click');
    $('.variant-input[data-value="CANVAS"] label[data-varcolorproduct="CANVAS"]').trigger('click');
    $('.variant-input[data-value="UNFRAMED"] label[data-varcolorproduct="UNFRAMED"]').trigger('click'); 
     $('#add-to-cart-btn').click();
  });
 

  $('.custom_frame_drawer .add_without_frame').click(function () {
    $('#custom_frame_drawer_container').removeClass('open');
  $('html').removeClass('js-drawer-open lock-scroll');
    $('.variant-input[data-value="UNFRAMED POSTER"] label[data-varcolorproduct="UNFRAMED POSTER"]').trigger('click');
    $('.variant-input[data-value="CANVAS"] label[data-varcolorproduct="CANVAS"]').trigger('click');
    $('.variant-input[data-value="UNFRAMED"] label[data-varcolorproduct="UNFRAMED"]').trigger('click'); 
     $('#add-to-cart-btn').click();
  });


  // info drawer
  $('.custom_frame_drawer .custom_frame_head_info').click(function () {
    $('.custom_information_drawer').addClass('open');
  });
  $('.custom_information_drawer .frame_drawer_close').click(function () {
    $('.custom_information_drawer').removeClass('open');
  });

  // item info drawer
  $('.custom_addon_item_wrapper .item_info').click(function () {
    $('.custom_item_info_drawer').addClass('open');
  });
  $('.custom_item_info_drawer .frame_drawer_close').click(function () {
    $('.custom_item_info_drawer').removeClass('open');
  });

  // item Frame info drawer
  $('.custom_frame_drawer .custom_frame_list_label').click(function () {
    $('.custom_item_frame_info_drawer').addClass('open');
  });
  $('.custom_item_frame_info_drawer .frame_drawer_close').click(function () {
    $('.custom_item_frame_info_drawer').removeClass('open');
  });

  // New Product Template Frame Drawer /////////
  
  
  
  // New Product Template Frame Drawer button/////////

(function ($) {

  function updateDrawerPrice() {

    var $checked = $('.variant-input-wrap-frame input[type="radio"]:checked');

    if ($checked.length > 0) {

      var pricehtml = $checked
        .closest('.variant-input') 
        .find('.option-price')
        .html();
      
      $('#drawertrigger .price-wrapper').html(pricehtml);
      // $('#custom_frame_drawer_container .custom_addon_item_wrapper .item_price').html(pricehtml);

    }
  }

 
function updateDrawerframePrice() {

  var $active = $('.drawer-color-option.active');

  if ($active.length === 0) return;

  var selectedValue = $active.data('value');

  // UNFRAMED CASE
  if (selectedValue === 'UNFRAMED POSTER' || selectedValue === 'CANVAS' || selectedValue === 'Canvas' || selectedValue === 'UNFRAMED' ) {

    $('#addtocarttrigger .addtocarttext')
      .text('Continue without frame');

    $('#addtocarttrigger .price-wrapper').html('');

  } else {

    var pricehtml = $active.find('.frameprice-new').html() || '';

    $('#addtocarttrigger .addtocarttext').html(
      'ADD FRAME TO CART <span>|</span> <span class="price-wrapper"></span>'
    );

    $('#addtocarttrigger .price-wrapper')
      .html(pricehtml);
  }
}





 $(document).on('click', '.drawer-color-option', function () {

    const value = $(this).data('value');

    const originalInput = document.querySelector(
        'fieldset[name="Frame Color"] input[type="radio"][value="'+value+'"]'
    );

    if (!originalInput) return;

    if (originalInput.disabled) {
        console.log('Variant combination not available');
        return;
    }

    originalInput.checked = true;
    originalInput.dispatchEvent(new Event('change', { bubbles: true }));

    $('.drawer-color-option').removeClass('active');
    $(this).addClass('active');
    
     updateDrawerframePrice(); 

});







  function ensureSelectedVariant() {

    var $checked = $('.variant-input-wrap-frame input[type="radio"]:checked');

    if ($checked.length === 0) {
      $('.variant-input-wrap-frame input[type="radio"]').first().prop('checked', true);
    }
  }

  // When DOM is ready
  $(document).ready(function () {

    ensureSelectedVariant();

   
    setTimeout(function () {
      updateDrawerPrice();
      updateDrawerframePrice();
    }, 100);

  });


  $(document).on('change', '.variant-input-wrap-frame input[type="radio"]', function () {
    updateDrawerPrice();
    updateDrawerframePrice();
  });

})(jQuery);



  // New Product Template Frame Drawer button/////////


$(document).on('click', '#addtocarttrigger', function (e) {
  e.preventDefault();

  $('#custom_frame_drawer_container').removeClass('open');

  var $checkedAddon = $('.item_check input[type="checkbox"]:checked');

  // Agar addon checked hai
  if ($checkedAddon.length) {
    var variantId = $checkedAddon.data('varid');

    // Add addon product first
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1    
      },
      dataType: 'json',
      success: function () {
        // After addon added, add main product
        $('#add-to-cart-btn').trigger('click');
      }
    });

  } else { 
    $('#add-to-cart-btn').trigger('click');
  } 
   
});
 



// frame drawer varaint price

// frame drawer varaint price




function updateFramePricesBySize() {

  var size = $('fieldset[name="Size"] input:checked').val();
  if (!size) return;

  /* ===============================
     BASE = UNFRAMED POSTER (THIS SIZE)
  ================================ */
  // var $unframedVariant = $('.all-variant-inner').filter(function () {
  //   return (
  //     $(this).data('option1') == size &&
  //     $(this).data('option2') == 'UNFRAMED POSTER'
  //   );
  // }).first();
  var $unframedVariant = $('.all-variant-inner').filter(function () {
  var opt2 = ($(this).data('option2') || '').toString().toLowerCase();
  return (
    $(this).data('option1') == size &&
    (opt2.includes('unframed') || opt2.includes('canvas'))
  );
}).first();

  if (!$unframedVariant.length) return;

  var basePrice = Number($unframedVariant.data('price')) || 0;
  var baseComp  = Number($unframedVariant.data('compprice')) || 0;

  /* ===============================
     UPDATE ALL FRAME OPTIONS
  ================================ */
  // $('fieldset[name="Frame Color"] .variant-input').each(function () {
  $('.drawer-frame-options .drawer-color-option').each(function () {

    var frameValue = $(this).data('value');
    var $priceBox  = $(this).find('.frameprice-new');

    /* UNFRAMED = ₹0 */
    if (frameValue === 'UNFRAMED POSTER' || frameValue === 'CANVAS' || frameValue === 'PRINT' || frameValue === 'UNFRAMED' ) {
      $priceBox.html('<span></span>');
      return;
    }

    /* Find variant for SIZE + FRAME */
    var $variant = $('.all-variant-inner').filter(function () {
      return (
        $(this).data('option1') == size &&
        $(this).data('option2') == frameValue
      );
    }).first();

    if (!$variant.length) {
      console.warn('Variant missing for:', size, frameValue);
      return;
    }

    var price = Number($variant.data('price')) || 0;
    var comp  = Number($variant.data('compprice')) || 0;

    var diffPrice = price - basePrice;
    var diffComp  = comp - baseComp;

    var sign = diffPrice > 0 ? '' : '';
    var html = sign + theme.Currency.formatMoney(diffPrice, theme.settings.moneyFormat);

    if (diffComp > diffPrice) {
      html += '<s>' + theme.Currency.formatMoney(diffComp, theme.settings.moneyFormat) + '</s>';
    }

    $priceBox.html(html);
  });
}

/* ONLY size drives price refresh */
$(document).on('change', 'fieldset[name="Size"] input', function () {
  updateFramePricesBySize();
});

/* Initial load */
$(document).ready(function () {
  updateFramePricesBySize();
});



